import React, {useState, useEffect}        from 'react';
import { Link }     from 'react-router-dom';
import * as config from '../../../config';
import { useTable, useFilters, useGlobalFilter, useAsyncDebounce } from 'react-table'
import { Table, Card, Row, ToggleButtonGroup, ToggleButton, InputGroup, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MdExpandMore } from "react-icons/md";
import styled from 'styled-components';
import {
  dateTimeToPSTString,
  joinObjectArrayToString,
  sortOpi,
  sortDate,
} from '../../../utils/formatFunctions';

const Styles = styled.div`
  headers{
    textAlign  :  'left',
    lineHeight :  '2rem',
  },
  img{
    height :  'auto',
    width  :  '24px',
  },
  table{
    height :  '75vh',
    border :  'none',
  },
  tableContainer{
    fontSize        :  '.94rem',
    boxSizing       :  'border-box',
    borderRadius    :  '4px',
    backgroundColor :  'rgb(250, 250, 250)',
    boxShadow'      :  'rgba(0, 0, 0, 0.2) 0px 0px 10px -2px',
  },
  tablePadding{
    borderLeft   : '1px solid #ddd',
    borderRight  : '1px solid #ddd',
    borderBottom : '1px solid #ddd',
  },
  unset{
    whiteSpace: 'unset'
  },
  prewrap {
    whiteSpace: 'pre-wrap'
  },
};`


function RenderTable({ columns, data }) {
  const filterTypes = React.useMemo(
    () => ({
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    visibleColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      // defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
    },
    useFilters, // useFilters!
    useGlobalFilter // useGlobalFilter!
  )

  // Define a default UI for filtering
  function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
  }) {
    const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
      document.getElementById("search-bar").focus()
    }, 800)

    return (
      <span>
        <InputGroup>
          <InputGroup.Prepend style={{margin: 'auto .5rem'}}>Filter{' '}</InputGroup.Prepend>
          <FormControl id="search-bar" value={value || ""}
            onChange={e => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
            placeholder={`${count} records...`}
            style={{
              fontSize: '1.1rem',
              borderTop: '0',
              borderBottom: '0'
            }} />
        </InputGroup>
      </span>
    )
  }

  return (
    <>
     <Card>
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={state.globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
      </Card>
      <Table bordered {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr style={{'backgroundColor': '#06a4e421'}} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => {
                const {render, getHeaderProps} = column
                return (
                  <th {...getHeaderProps()}>{render("Header")}</th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} style={i % 2 === 1 ? {'backgroundColor': '#06a4e421'} : {}}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}

const SubscriptionPreferenceTable = ({RowData}) => {
  const [row_data, set_row_data] = useState(RowData)

  const { t } = useTranslation(["translation"]);
  const headerStyle = {
    textAlign  :  'left',
    lineHeight :  '2rem',
  }

  const columns = React.useMemo(
    () => [
        {
          Header: <b data-cy='data-center-header'>Application</b>,
          headerStyle: headerStyle,
          id: 'application',
          width: 220,
          accessor: (data) => data.application,
          filter: 'includes'
        },
        {
          Header: <b data-cy='data-center-header'>Comm Type</b>,
          headerStyle: headerStyle,
          id: 'comm_type',
          width: 220,
          accessor: (data) => data.comm_type,
          filter: 'includes'
        },
        {
          Header: <b data-cy='data-center-header'>Data Center</b>,
          headerStyle: headerStyle,
          id: 'data_center',
          width: 500,
          accessor: (data) => data.data_center,
          filter: 'includes'
        },
        {
          Header: <b data-cy='start-date-header'>Service</b>,
          headerStyle: headerStyle,
          id: 'service',
          width: 240,
          accessor: (data) => data.service,
          filter: 'includes',
        },
        {
          Header: <b data-cy='end-date-header'>Message Type</b>,
          headerStyle: headerStyle,
          id: 'message_type',
          width: 240,
          accessor: (data) => data.message_type,
          filter: 'includes',
        },  
        {
          Header: <b data-cy='created-on-header'>Created On</b>,
          headerStyle: headerStyle,
          id: 'created_on',
          width: 240,
          accessor: (data) => dateTimeToPSTString(data.created_on),
          filter: 'includes',
        },   
      ],
    []
  )
  return (
    <Styles>
      <RenderTable columns={columns} data={row_data} />
    </Styles>
      
  )
}

export default SubscriptionPreferenceTable;
